import { normalizeArtifactPrompt } from '@/utils/generatedArtifactAssistantPayloadPatterns.js'

export function isCreateAgentQuestionPrompt(trimmed) {
  return normalizeArtifactPrompt(trimmed).toLowerCase() === 'create'
}
